import axios from 'axios';

// Base API URL - update with your actual API Gateway URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://0to3541m56.execute-api.us-east-2.amazonaws.com/dev';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token and cache-busting to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Add timestamp to prevent caching (removed Cache-Control/Pragma headers to avoid CORS issues)
  if (!config.params) {
    config.params = {};
  }
  config.params._t = Date.now();
  
  return config;
});

// Timbrado APIs
// Omit fechaComprobante to retrieve every timbrado registered for the RUC.
export const buscarTimbrado = async (ruc, fechaComprobante) => {
  const response = await api.post('/api/timbrados/search', {
    ruc,
    ...(fechaComprobante ? { fecha_comprobante: fechaComprobante } : {}),
  });
  return response.data;
};

export const registrarTimbrado = async (timbradoData) => {
  const response = await api.post('/api/timbrados', timbradoData);
  return response.data;
};

// Lookup razon social by RUC from the SET public contribuyente registry
export const consultarContribuyente = async (ruc) => {
  const response = await axios.get(`https://turuc.com.py/api/contribuyente/${ruc}`);
  return response.data.data;
};

// Comprobante APIs
export const crearComprobante = async (comprobanteData) => {
  const response = await api.post('/api/comprobantes', comprobanteData);
  return response.data;
};

export const listarComprobantes = async (params = {}) => {
  const response = await api.get('/api/comprobantes', { params });
  return response.data;
};

export const eliminarComprobante = async (id) => {
  const response = await api.delete(`/api/comprobantes/${id}`);
  return response.data;
};

export const actualizarComprobante = async (id, comprobanteData) => {
  const response = await api.put(`/api/comprobantes/${id}`, comprobanteData);
  return response.data;
};

// Export APIs
export const exportarDNIT = async (exportData) => {
  const response = await api.post('/api/exports/dnit', exportData);
  return response.data;
};

export const obtenerSiguienteID = async (periodo) => {
  const response = await api.get(`/api/exports/next-id?periodo=${periodo}`);
  return response.data;
};

// Archive APIs
export const listarArchivos = async (params = {}) => {
  const response = await api.get('/api/archives', { params });
  return response.data;
};

// Bulk import
export const importarCSV = async (formData) => {
  const response = await api.post('/api/comprobantes/bulk-import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export default api;
